import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import {
  Container as BaseContainer,
  topBorder,
  cardBase,
  PrimaryButton,
  SectionHeading,
  SectionSub
} from './GlobalStyle';
import { useI18n } from '../i18n';
import micuencaLogo from '../assets/projects/micuenca.webp';
import logoberrik from '../assets/projects/berrik_logo.webp';

const Section = styled.section`
  padding: 4.5rem 2rem;
  background: ${({ theme }) => theme.colors.bg};
  ${topBorder}
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 3rem 1rem;
  }
`;

const Container = BaseContainer;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2rem;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }
`;

const Card = styled(motion.article)`
  ${cardBase}
  overflow: hidden;
  display: flex;
  flex-direction: column;
  img {
    width: 100%;
    height: 240px;
    object-fit: cover;
  }
  .content {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  h3 {
    margin: 0 0 0.6rem;
    color: ${({ theme }) => theme.colors.brandDark};
    font-size: 1.4rem;
    font-weight: 800;
  }
  p {
    margin: 0 0 1rem;
    color: ${({ theme }) => theme.colors.muted};
    line-height: 1.6;
  }
`;

const Action = styled(PrimaryButton)`
  margin-top: auto;
  align-self: flex-start;
`;

const ProjectsNews = () => {
  const { t } = useI18n();
  const items = [
    {
      type: 'project',
      title: t('home.projectMicuencaTitle'),
      description: t('home.projectMicuencaDesc'),
      image: micuencaLogo
    },
    {
      type: 'news',
      title: t('home.newsOpenClientsTitle'),
      description: t('home.newsOpenClientsDesc'),
      image: logoberrik
    }
  ];

  return (
    <Section id="projects">
      <Container>
        <SectionHeading
          as={motion.h2}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          {t('home.projectsNewsHeader')}
        </SectionHeading>
        <SectionSub>{t('home.projectsNewsSub')}</SectionSub>
        <Grid>
          {items.map((item, i) => (
            <Card
              key={item.type}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              viewport={{ once: true }}
            >
              <img src={item.image} alt={item.title} loading="lazy" decoding="async" />
              <div className="content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                {item.type === 'project' ? (
                  <Action
                    as="a"
                    href="https://micuenca.cl"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('home.actionViewProjects')}
                  </Action>
                ) : (
                  <Action to="/about">{t('home.actionAboutUs')}</Action>
                )}
              </div>
            </Card>
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export default ProjectsNews;
